import { render, staticRenderFns } from "./ProductReportsDashboardBriefModal.vue?vue&type=template&id=25782152&scoped=true"
import script from "./ProductReportsDashboardBriefModal.vue?vue&type=script&lang=js"
export * from "./ProductReportsDashboardBriefModal.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsDashboardBriefModal.vue?vue&type=style&index=0&id=25782152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25782152",
  null
  
)

export default component.exports